export default "__VITE_ASSET__DtqQIwcL__"